import Styles from './NSLayout.module.css';
import { Fragment, ReactNode } from 'react';
import { NSHeader } from './NSHeader';
import { NSFooter } from './NSFooter';
import { IBaseComponentProps } from '../props/IBaseComponentProps';
import { NSBarNotification, NSBarNotificationProps } from './NSBarNotification';
import { IHeaderProps } from '../props/IHeaderProps';
import { NSBarActionProps, NSBarAction, isValidAction } from './NSBarAction';
import { NSBarTitleProps, NSBarTitle } from './NSBarTitle';
import { NSRouterMakerProps } from '../routing/NSRouterMakerProps';
import { NSBarAlertProps, NSBarAlert } from './NSBarAlert';
import { NSSpace, NSSpaceSizeType } from './NSSpace';
import { IBackgroundProps } from '../props/IBackgroundProps';

export interface NSLayoutProps extends IBaseComponentProps, NSRouterMakerProps
{
	scope: string;
	logo: string;
	background?: IBackgroundProps;
	header: IHeaderProps;
	notifications: NSBarNotificationProps[];
	action?: NSBarActionProps;
	alerts?: NSBarAlertProps[];
	title?: NSBarTitleProps;
	children: ReactNode;
	isLoggedIn: () => boolean;
	onEnterPressed?: () => void;
}

export function NSLayout(props: NSLayoutProps)
{
	let alerts = props.alerts ?? [];
	alerts = alerts.filter((a) => a.isVisible());

	return (
		<div id={props.id}
			className={`${Styles.ns_container} ${props.classList?.join(" ") ?? ""}`}
			style={{
				minHeight: "100vh",
				width: "100%",
				display: "flex",
				flexDirection: "column",
				justifyContent: "center",
				background: props.background?.image ? `url(${props.background?.image})` : "",
				backgroundSize: props.background?.size ?? "cover",
				backgroundAttachment: props.background?.attachment ?? "fixed"
			}}
			onKeyUp={e =>
			{
				if (e.key === "Enter")
					props.onEnterPressed?.();
			}}
		>
			<NSHeader
				scope={props.scope}
				name="Header"
				logo={props.logo}
				header={props.header}
				isLoggedIn={props.isLoggedIn}
				notifier={props.notifier}
			>
				{
					props.notifications.length !== 0 &&
					<>
						{
							props.notifications.map((notification, index) =>
								<Fragment key={`NSLayout_fragment_key_${index}`}>
									<NSBarNotification
										{...notification}
										onClose={() =>
										{
											props.notifier.delNotification(notification.id);
										}}
										onChangeState={() =>
										{
											props.notifier.onChangeState();
										}}
									/>
								</Fragment>
							)
						}
					</>
				}
				{/* Desktop */}
				<div className='d-none d-lg-block'>
					{
						alerts.length !== 0 && alerts.map((alert, index) => <NSBarAlert key={`NSLayout_NSBarAlert_key_${index}`} {...alert} />)
					}
					{
						isValidAction(props.action) &&
						<NSBarAction
							{...props.action}
						/>
					}
				</div>
				{/* Desktop */}
			</NSHeader>
			<div className='d-block d-lg-none'>
				{/* Mobile */}
				{
					alerts.length !== 0 && alerts.map((alert, index) => <NSBarAlert key={`NSLayout_NSBarAlert_key_${index}`} {...alert} />)
				}
				{
					isValidAction(props.action) && <NSBarAction {...props.action} />
				}
			</div>
			{/* Mobile */}
			{
				props.title &&
				<>
					<NSSpace size={NSSpaceSizeType.MINI}
					></NSSpace>
					<NSBarTitle {...props.title} ></NSBarTitle >
				</>
			}
			<main className={`d-flex flex-column text-white ${Styles.ns_layout_main}`}>
				{props.children}
			</main>
			<NSFooter
				scope={props.scope}
				name="Footer"
				logo={props.logo}
				isLoggedIn={props.isLoggedIn}
			/>
		</div >
	);
}